import type { ConciseBranch } from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

export const useStandardComponentConciseBranch = (
  enabled: boolean,
): Optional<ConciseBranch> => {
  const translate = useTranslate()

  return enabled
    ? { _type: 'ConciseBranch', name: translate('branch.default') }
    : null
}
